module.exports = __webpack_public_path__ + "img/pop_up.7b8dd275.png";